import React, { useEffect } from 'react';
import { Form, Formik, FormikProps } from 'formik';
import axios from 'axios';
import { useDispatch } from 'react-redux';

import { yup as yupCreator } from 'services';

import * as Actions from '../actions';
import * as Types from '../types';

interface FormValues extends Types.IForm.LoginViaEmail {}

interface IChildren extends FormikProps<FormValues> {}

interface IProps {
  onSuccess?: () => void;
  onError?: ({ error }: { error: Types.IEntity.LangStrings }) => void;
  onFinally?: () => void;
  children(props: IChildren): JSX.Element;
}

let cancelSource = axios.CancelToken.source();

const LoginViaEmail: React.FC<IProps> = ({ onSuccess = () => {}, onError = () => {}, onFinally = () => {}, children }) => {
  const dispatch = useDispatch();

  useEffect(() => () => cancelSource.cancel('canceled'), []);

  const yup = yupCreator();
  const validationSchema = (
    yup.object().shape<FormValues>({
      email: yup.string().email().required(),
      password: yup.string().min(6).required()
    })
  );

  const handleSubmit = (values: FormValues, { isSubmitting, setSubmitting }: FormikProps<FormValues>) => {
    if (!isSubmitting) {
      setSubmitting(true);
      cancelSource = axios.CancelToken.source();

      dispatch(Actions.LoginViaEmail.request({
        values,
        cancelSource,
        callback: {
          onSuccess,
          onError: (error) => {
            setSubmitting(false);
            onError(error);
          },
          onFinally
        }
      }));
    }
  };

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={{
        email: '',
        password: ''
      }}
      validateOnMount
      enableReinitialize
      {...{ validationSchema }}
    >
      {(props: FormikProps<FormValues>) => (
        <Form style={{ height: '100%' }}>
          {children(props)}
        </Form>
      )}
    </Formik>
  );
};

export default LoginViaEmail;
